module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_trouble02-eed9606ef2e7d41c97287d4901b33bd6.png";